export default __webpack_public_path__ + "static/media/randy-testemonial.6cde0de1.png";